module.exports = __webpack_public_path__ + "img/logo-Visa.d2fb6a90.png";